import React, { useEffect, useState } from "react";
import Axios from "../../Axios";
import { Card, Table } from "antd";
import { formatNumber, formatPercentage } from "../../helpers/formatters";
import { render } from "less";

const PenaltiesSummaryTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const fetchData = async () => {
    setIsloading(true);
    try {
      const res = await Axios.get("/analytics/fines-summary");
      const { today, week, month } = res.data;

      const operators = new Map();

      [today, week, month].forEach((list, i) => {
        const periodKey = ["today", "week", "month"][i];
        list.forEach(item => {
          if (!operators.has(item.operator_fullname)) {
            operators.set(item.operator_fullname, { operator: item.operator_fullname });
          }
          operators.get(item.operator_fullname)[periodKey] =
            `${formatNumber(item.qty)} (${formatPercentage(item.percentage)})`;
        });
      });

      setData(Array.from(operators.values()));
    } catch (error) {
      console.error("Error al cargar resumen de operadores:", error);
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    { title: "Operador", dataIndex: "operator", key: "operator" },
    { title: "Hoy", dataIndex: "today", key: "today", align: "right" , render: (value) => value ?? '-'},
    { title: "Esta Semana", dataIndex: "week", key: "week", align: "right" , render: (value) => value ?? '-'},
    { title: "Este Mes", dataIndex: "month", key: "month", align: "right" , render: (value) => value ?? '-'},
  ];

  return (
    <Card title="Resumen de Multas por Operador" style={{ marginTop: "10px" }}>
      <Table
        size="small"
        columns={columns}
        dataSource={data}
        loading={isLoading}
        rowKey={(record) => record.operator}
        pagination={false}
      />
    </Card>
  );
};

export default PenaltiesSummaryTable;
